import React from 'react'
import PropTypes from 'prop-types'
import {
  RegistrationWrapper,
  RightContainer,
  SignUpContainer,
} from '../../Signup/styled'
import { LeftContainer } from '../../Signup/components/LeftContainer'
import { MAX_TAB_WIDTH } from '../../../author/src/constants/others'
import MfaVerification from './MfaVerification'

const MfaLoginLayout = ({
  windowWidth,
  isSignupUsingDaURL,
  generalSettings,
  backgroundImage,
}) => {
  const isDistrictSignup = generalSettings?.pageBackground && isSignupUsingDaURL

  return (
    <RegistrationWrapper image={backgroundImage}>
      {windowWidth > MAX_TAB_WIDTH && (
        <LeftContainer
          currentPage="getstarted"
          isDistrictSignup={isDistrictSignup}
        />
      )}
      <RightContainer windowWidth={windowWidth}>
        <SignUpContainer isDistrictSignup={isDistrictSignup}>
          <MfaVerification />
        </SignUpContainer>
      </RightContainer>
    </RegistrationWrapper>
  )
}

MfaLoginLayout.propTypes = {
  windowWidth: PropTypes.number.isRequired,
  isSignupUsingDaURL: PropTypes.bool,
  generalSettings: PropTypes.object,
  backgroundImage: PropTypes.string,
}

MfaLoginLayout.defaultProps = {
  isSignupUsingDaURL: false,
  generalSettings: null,
  backgroundImage: '',
}

export default MfaLoginLayout
